module.exports = __webpack_public_path__ + "img/Winner-3.ad77d807.jpg";